import { render, staticRenderFns } from "./GovernmentRequests.vue?vue&type=template&id=541b00c2"
import script from "./GovernmentRequests.vue?vue&type=script&lang=js"
export * from "./GovernmentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports